import { render, staticRenderFns } from "./OpeningHoursDialog.vue?vue&type=template&id=47414f7f&scoped=true&"
import script from "./OpeningHoursDialog.vue?vue&type=script&lang=js&"
export * from "./OpeningHoursDialog.vue?vue&type=script&lang=js&"
import style0 from "./OpeningHoursDialog.vue?vue&type=style&index=0&id=47414f7f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47414f7f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VCard,VDialog,VIcon})
